export default function required(
  value,
  { match, nullable = false, numeric = false, locale = {} } = {}
) {
  if (nullable && value === null && match === null) return false;
  if (numeric && value === 0) return false;

  if (!value || !`${value}`.replace(/\s/gi, '')) {
    return locale.required || 'This field is required';
    // 'Please fill out this field.'
  }

  return false;
}
